export type MediaTrackErrorKey = 'deviceAlreadyInUse' | 'notReadableError' | 'permissionDenied' | 'unexpectedError';

export enum BlurState {
  Idle = 'idle',
  InProgress = 'in progress',
}

export type BlurLevel = 0 | 1 | 2 | 3;

export type MediaSettingsState = {
  videoDeviceId: string;
  audioInputDeviceId: string;
  audioOutputDeviceId: string;
  blurLevel: BlurLevel;
};

export type MediaDevice = Pick<MediaDeviceInfo, 'deviceId' | 'groupId' | 'kind' | 'label'>;

export enum MediaSettingsTab {
  Video,
  Audio,
}
